import { api } from '../configs/apiConfig';

const BASE_URL = '/LeaveType';

export const leaveTypeService = {
    getAllLeaveTypes: async () => {
        try {
            const response = await api.get(BASE_URL);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getActiveLeaveTypes: async () => {
        try {
            const response = await api.get(`${BASE_URL}/active`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getLeaveTypeById: async (id) => {
        try {
            const response = await api.get(`${BASE_URL}/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    createLeaveType: async (leaveTypeData) => {
        try {
            const response = await api.post(BASE_URL, leaveTypeData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateLeaveType: async (id, leaveTypeData) => {
        try {
            const response = await api.put(`${BASE_URL}/${id}`, leaveTypeData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    deleteLeaveType: async (id) => {
        try {
            await api.delete(`${BASE_URL}/${id}`);
            return true;
        } catch (error) {
            throw error;
        }
    }
}; 